import React from 'react';
import { BookOpenIcon, BoneIcon, FlameIcon, LayoutGridIcon, MapPinIcon, PrinterIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { OptimizedImage } from '../OptimizedImage';
import { printPackItems } from '../../data/salesContent';
import { PRINT_PACK_IMAGE } from '../../data/product';
const itemIcons = [BookOpenIcon, FlameIcon, MapPinIcon, LayoutGridIcon, BoneIcon];
export function PrintPackSection() {
  return <section className="bg-night py-8 sm:py-12" aria-labelledby="print-title" data-id="element-138" data-mp="2q3rsr3j1dqaq">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-139" data-mp="2l344uqq3tpkq">
        <div id="print-title" data-id="element-140" data-mp="2gblzzrkyn4uh">
          <SectionHeading eyebrow="Included with your access" title={<>
                Print It. Cut It. <span className="text-pumpkin" data-id="element-142" data-mp="2baolpq32muy9">Use It.</span>
              </>} subtitle="You also receive a separate printable resource pack designed for practical classroom use." data-id="element-141" data-mp="2gakq3qfokoec" />
        </div>

        <div className="mt-5 grid gap-5 lg:grid-cols-[1.2fr_1fr] lg:items-center lg:gap-10" data-id="element-143" data-mp="3vpazutw459zo">
          <figure data-id="element-144" data-mp="3l0d49sdqh6c">
            <OptimizedImage src={PRINT_PACK_IMAGE} alt="Halloween Print & Play Pack: teacher quick guide, warm-up routine, four corner signs, movement cards and a Build-a-Skeleton sheet" width={1200} height={896} widths={[400, 700, 1000]} sizes="(min-width: 1024px) 680px, 92vw" className="h-auto w-full rounded-3xl border border-line" data-id="element-145" data-mp="3li68xjqwfa1" />
            <figcaption className="mt-3 flex items-start gap-3 rounded-2xl bg-lime/10 p-3 text-[14px] leading-snug text-cream" data-id="element-146" data-mp="3gy21nwe5agax">
              <PrinterIcon className="mt-0.5 h-5 w-5 shrink-0 text-lime" aria-hidden="true" data-id="element-147" data-mp="37z6vgkb3p67m" />
              Designed separately for printing so teachers do not need to print the dark digital guide.
            </figcaption>
          </figure>

          <ul className="space-y-3.5" data-id="element-148" data-mp="166sh1v7rmjvy">
            {printPackItems.map((item, i) => {
            const Icon = itemIcons[i];
            return <li key={item.title} className="flex gap-3" data-id="element-149" data-mp="zrv0qvlh7owf" data-mpi={i}>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-panel text-pumpkin" data-id="element-150" data-mp="zqjw6tk7id49">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-151" data-mp="uuld9lhndnb8" />
                  </span>
                  <div data-id="element-152" data-mp="pvs0jva6q0c4">
                    <h3 className="font-display text-sm font-extrabold uppercase tracking-wide text-cream" data-id="element-153" data-mp="1nh64mly4hzes">{item.title}</h3>
                    <p className="mt-0.5 text-[13px] leading-snug text-muted sm:text-sm" data-id="element-154" data-mp="1ii2z70e8dr6a">{item.text}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}